import * as THREE from 'three';
import { buildAssetModel, type AssetId } from '../game/assets';
import { sharedEnvironment } from '../engine/envlight';

// Renders the REAL asset prop model (barrel / crate / junk / toolbox) to a small transparent PNG, cached by id, so the
// /admin loot tables show the actual game asset instead of an abstract icon. One tiny offscreen renderer, reused.

let renderer: THREE.WebGLRenderer | null = null;
const cache = new Map<string, string>();

export function assetThumb(id: string, size = 128): string {
  const key = id + ':' + size;
  const hit = cache.get(key); if (hit != null) return hit;
  try {
    if (!renderer) {
      renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true, preserveDrawingBuffer: true });
      renderer.setClearColor(0x000000, 0);
      renderer.outputColorSpace = THREE.SRGBColorSpace;
    }
    renderer.setSize(size, size, false);
    const scene = new THREE.Scene();
    scene.environment = sharedEnvironment(renderer); // metals are BLACK without an env map (MODELING.md)
    scene.environmentIntensity = 0.85;
    const model = buildAssetModel(id as AssetId);
    scene.add(model);
    scene.add(new THREE.HemisphereLight(0xffffff, 0x202428, 1.45));
    const dir = new THREE.DirectionalLight(0xfff0e0, 1.35); dir.position.set(2.5, 4, 3); scene.add(dir);
    const box = new THREE.Box3().setFromObject(model);
    const sz = box.getSize(new THREE.Vector3()), ctr = box.getCenter(new THREE.Vector3());
    const maxDim = Math.max(sz.x, sz.y, sz.z) || 1;
    const cam = new THREE.PerspectiveCamera(31, 1, 0.05, 100);
    const dist = maxDim * 2.45;
    cam.position.set(ctr.x + dist * 0.78, ctr.y + dist * 0.58, ctr.z + dist * 0.9);
    cam.lookAt(ctr.x, ctr.y, ctr.z);
    renderer.render(scene, cam);
    const url = renderer.domElement.toDataURL('image/png');
    model.traverse((o) => { const m = o as THREE.Mesh; if (m.isMesh) { m.geometry?.dispose(); const mat = m.material; (Array.isArray(mat) ? mat : [mat]).forEach((x) => x?.dispose?.()); } });
    cache.set(key, url);
    return url;
  } catch {
    cache.set(key, ''); return '';
  }
}
